import { useEffect, useState } from 'react';
import { useQuery } from '@/hooks/useQuery';
import { api } from '@/services/api';
import type { CommoditiesResponse } from '@/types';

const REFRESH_MS = 5 * 60 * 1000; // 5 minutes — commodities/forex move faster than equities

export function useCommodities(): { data: CommoditiesResponse | null; loading: boolean; error: string | null } {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), REFRESH_MS);
    return () => window.clearInterval(id);
  }, []);

  return useQuery<CommoditiesResponse>(() => api.commodities(), [tick]);
}
